import { put, takeLatest } from "redux-saga/effects";
import { push } from "connected-react-router";

const SEND_NEW_BRAND_STATION = "SEND_NEW_BRAND_STATION";
const EDIT_BRAND_STATION = "EDIT_BRAND_STATION";
const SUCCESS_NEW_BRAND_STATION = "SUCCESS_NEW_BRAND_STATION";
const ERROR_NEW_BRAND_STATION = "ERROR_NEW_BRAND_STATION";
const CLEAR_ERROR_NEW_BRAND_STATION = "CLEAR_ERROR_NEW_BRAND_STATION";
const SET_ERROR_NEW_BRAND_STATION = "SET_ERROR_NEW_BRAND_STATION";

const INITIAL_STATE = {
  isLoading: false,
  error: false,
  errorMessage: "",
  message: "",
};

const newBrandStationReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SEND_NEW_BRAND_STATION:
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: "",
        message: "",
      };
    case EDIT_BRAND_STATION:
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: "",
        message: "",
      };
    case SUCCESS_NEW_BRAND_STATION:
      return {
        ...state,
        isLoading: false,
        message: payload,
      };
    case ERROR_NEW_BRAND_STATION:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: payload.message,
      };
    case SET_ERROR_NEW_BRAND_STATION:
      return {
        ...state,
        error: true,
        errorMessage: payload,
      };
    case CLEAR_ERROR_NEW_BRAND_STATION:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };
    default:
      return state;
  }
};

function sendNewBrandStation(body) {
  return { type: SEND_NEW_BRAND_STATION, body };
}

function editBrandStation(body, id) {
  return { type: EDIT_BRAND_STATION, body, id };
}

function setError(error) {
  return { type: SET_ERROR_NEW_BRAND_STATION, payload: error };
}

function clearError() {
  return { type: CLEAR_ERROR_NEW_BRAND_STATION };
}

function* sendForm() {
  try {
    yield put({
      type: SUCCESS_NEW_BRAND_STATION,
      payload: "Guardado con éxito",
    });
    yield put(push("/admin/marcas"));
  } catch (message) {
    yield put({
      type: ERROR_NEW_BRAND_STATION,
      payload: { message },
    });
  }
}

function* editForm() {
  try {
    yield put({
      type: SUCCESS_NEW_BRAND_STATION,
      payload: "Guardado con éxito",
    });
    yield put(push("/admin/marcas"));
  } catch (message) {
    yield put({
      type: ERROR_NEW_BRAND_STATION,
      payload: { message },
    });
  }
}

function* newBrandStationSaga() {
  yield takeLatest(SEND_NEW_BRAND_STATION, sendForm);
  yield takeLatest(EDIT_BRAND_STATION, editForm);
}

export {
  newBrandStationSaga,
  newBrandStationReducer,
  sendNewBrandStation,
  editBrandStation,
  setError,
  clearError,
};
